// Anthology product page "numbered step" accordion - matches the old
// theme's 1. BASE METAL / 2. COLOR / 3. FRONT convention: only steps
// other than the first and last are collapsible (start collapsed with a
// one-line summary + chevron); the first and last steps always stay
// fully expanded, matching the old design exactly. Purely a
// presentational layer on top of the native variant-picker and the
// anthology-customizer element: it never removes inputs from the DOM, so
// nothing about variant selection, pricing or add-to-cart is affected by
// collapsing/expanding a step.
//
// Color and Size are both exceptions to "start collapsed": they are open
// when the page loads (so both the metal-tone swatch and the ring size grid
// are visible without an extra click), and a Base Metal choice re-opens
// Color again (openColorNext) in case the customer had closed it. Size isn't
// re-opened on Base Metal change - only its own initial state differs.
//
// Steps do NOT auto-collapse when a value is picked inside them - only a
// header click (or a Base Metal change re-opening Color) changes a step's
// open/closed state. This was tried and reverted per Ian's request.
//
// The variant picker re-renders its option steps after every change: it
// fetches the new section HTML and swaps in brand-new DOM nodes. Restoring
// the step state only after that swap (the old approach) made the Color step
// flash open for ~100ms and flicker its label. Instead the state is copied
// onto the incoming nodes in the picker's own on:variant:before-replace-element
// event, before they are inserted, so they arrive already collapsed/expanded.
// Header clicks and change events are delegated from the document for the
// same reason (the nodes they used to be bound to get replaced).
//
// This file is linked by both variant-picker.liquid and product-customizer.liquid,
// so on customizer products it is loaded twice; the guard below stops the
// document-level listeners from being registered twice (two click handlers
// would toggle a step open and shut again, so a header click did nothing).
(function () {
  if (window.__anthologyProductSteps) return;
  window.__anthologyProductSteps = true;

  var METAL_OPTIONS = ['Base Metal', 'Material', 'Metal'];
  // Steps that start OPEN on page load. "Finish and Enamel" is the enamel
  // necklaces' color choice, so it behaves like Color; "Block Count" sets
  // both the price and how many characters block jewelry asks for; the
  // Birthstone picker (data-option is always normalised to "Birthstone Month"
  // by variant-picker.liquid) opens so the stones are visible straight away.
  var OPEN_ON_LOAD = ['Color', 'Size', 'Finish and Enamel', 'Block Count', 'Birthstone Month'];
  var openColorNext = false;

  function summaryFor(step) {
    if (step.tagName === 'ANTHOLOGY-CUSTOMIZER') {
      var select = step.querySelector('#anthology-customize-select');
      if (select && select.selectedOptions.length) {
        return select.selectedOptions[0].textContent.trim();
      }
      var checkedType = step.querySelector('.anthology-customize-type-input:checked');
      if (checkedType) return checkedType.value;
      return '';
    }
    var checked = step.querySelector('.js-option:checked, .js-option[aria-selected="true"]');
    return checked ? checked.value : '';
  }

  function getHeader(step) {
    return step.tagName === 'ANTHOLOGY-CUSTOMIZER'
      ? step.querySelector('#anthology-customize-label')
      : step.querySelector('legend');
  }

  function ensureHeaderStructure(step, collapsible) {
    var header = getHeader(step);
    if (!header || header.dataset.stepHeaderInit) return header;

    header.dataset.stepHeaderInit = 'true';
    header.classList.add('product-step__header');

    if (collapsible) {
      var value = document.createElement('span');
      value.className = 'product-step__value';
      header.appendChild(value);
    }

    return header;
  }

  // Option steps (Size, Block Count, ...) always show the picked value right
  // after their name, open or collapsed - the same way Color always shows its
  // swatch + name. The customizer step only shows its type when collapsed.
  function updateSummary(step) {
    var header = getHeader(step);
    if (!header) return;
    var valueEl = header.querySelector('.product-step__value');
    if (!valueEl) return;
    var show = step.tagName !== 'ANTHOLOGY-CUSTOMIZER' || step.classList.contains('product-step--collapsed');
    valueEl.textContent = show ? summaryFor(step) : '';
  }

  function collectSteps(container) {
    var steps = [];
    container.querySelectorAll('variant-picker').forEach(function (vp) {
      vp.querySelectorAll(':scope > .option-selector').forEach(function (el) {
        steps.push(el);
      });
    });
    var customizer = container.querySelector('anthology-customizer');
    if (customizer) steps.push(customizer);
    return steps;
  }

  function init() {
    var openColor = openColorNext;

    document.querySelectorAll('.js-product').forEach(function (container) {
      var steps = collectSteps(container);
      if (steps.length < 2) return;

      steps.forEach(function (step, index) {
        step.classList.add('product-step');
        var isFirst = index === 0;
        var isLast = index === steps.length - 1;
        var collapsible = !isFirst && !isLast;

        if (collapsible) step.classList.add('product-step--collapsible');

        ensureHeaderStructure(step, collapsible);

        if (!step.dataset.stepDefaultSet) {
          step.dataset.stepDefaultSet = 'true';
          // Every collapsible step starts collapsed except the OPEN_ON_LOAD ones.
          if (collapsible && OPEN_ON_LOAD.indexOf(step.dataset.option) === -1) {
            step.classList.add('product-step--collapsed');
          }
        }

        if (openColor && collapsible && step.dataset.option === 'Color') {
          step.classList.remove('product-step--collapsed');
        }

        updateSummary(step);
      });
    });

    if (openColor) openColorNext = false;
  }

  // Header click: expand / collapse a collapsible step.
  document.addEventListener('click', function (evt) {
    var header = evt.target.closest && evt.target.closest('.product-step--collapsible > .product-step__header');
    if (!header) return;
    var step = header.parentElement;
    evt.preventDefault();
    step.classList.toggle('product-step--collapsed');
    updateSummary(step);
  });

  // A change inside a step: refresh its one-line summary, and remember that a
  // Base Metal choice should open Color once the picker has re-rendered.
  document.addEventListener('change', function (evt) {
    var step = evt.target.closest && evt.target.closest('.product-step');
    if (!step) return;
    if (METAL_OPTIONS.indexOf(step.dataset.option) > -1) openColorNext = true;
    updateSummary(step);
  });

  // Carry each step's collapsed/expanded state onto the freshly rendered nodes
  // before the variant picker swaps them in.
  document.addEventListener('on:variant:before-replace-element', function (evt) {
    var detail = evt.detail || {};
    var oldEl = detail.toReplace;
    var newEl = detail.replaceWith;
    if (!oldEl || !newEl || !oldEl.querySelectorAll || !newEl.querySelectorAll) return;

    var oldSteps = {};
    oldEl.querySelectorAll('.option-selector.product-step').forEach(function (s) {
      oldSteps[s.dataset.option] = s;
    });

    newEl.querySelectorAll('.option-selector').forEach(function (step) {
      var old = oldSteps[step.dataset.option];
      if (!old) return;

      var collapsible = old.classList.contains('product-step--collapsible');
      var collapsed = old.classList.contains('product-step--collapsed');
      if (collapsible && openColorNext && step.dataset.option === 'Color') collapsed = false;

      step.classList.add('product-step');
      if (collapsible) step.classList.add('product-step--collapsible');
      step.classList.toggle('product-step--collapsed', collapsed);
      step.dataset.stepDefaultSet = 'true';
      ensureHeaderStructure(step, collapsible);
      updateSummary(step);
    });
  });

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('on:variant:change', function () {
    setTimeout(init, 50);
  });
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 50);
  });
})();
